<template>
  <div class="page-wrap">
    <div class="page-left">
      <a-form-model :model="query" ref="form" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item :label="$t('page_andon_call_accept')" prop="type">
          <a-select v-model="query.workStationId"
          :placeholder="$t('please_select')+$t('page_workstation_management')"
          show-search
          optionFilterProp="children"
          allowClear
          >
            <a-select-option :value="item.id" v-for="(item,index) in workStations" :key="index">
              {{item.code}}-{{item.name}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon_call_type')">
        <a-select v-model="query.andonTypeId"
          :placeholder="$t('please_select')+$t('page_andon_call_type')"
          show-search
          optionFilterProp="children"
          allowClear
          >
            <a-select-option :value="item.id" v-for="(item,index) in typeList" :key="index">
              {{item.codeAndName}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_andon_call_reason')">
       <a-select v-model="query.andonReasonId"
          :placeholder="$t('please_select')+$t('page_andon_call_reason')"
          show-search
          optionFilterProp="children"
          allowClear
          >
            <a-select-option :value="item.id" v-for="(item,index) in reasonList" :key="index">
              {{item.codeAndName}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
      <a-form-model-item :label="$t('page_devices_management_satus')">
        <a-select v-model="query.status"
          :placeholder="$t('please_select')+$t('page_devices_management_satus')"
          show-search
          optionFilterProp="children"
          allowClear
          >
            <a-select-option :value="item.value" v-for="(item,index) in stateList" :key="index">
              {{item.label}}
            </a-select-option>
          </a-select>
      </a-form-model-item>
    </a-form-model>
    <div class="action">
      <a-button type="default" @click="onReset">
        {{$t('common_reset')}}
      </a-button>
      <a-button type="primary" style="margin-left:10px;" @click="onSearch">
        {{$t('common_search')}}
      </a-button>
    </div>
    </div>
    <div v-resize="'x'"></div>
    <div class="page-right">
      <div class="top-action">
        <a-button type="primary" :disabled="!isAccept"  @click="onCallAccept">
          {{$t('page_andon_call_accept')}}
        </a-button>
      </div>
      <div class="table-wrap">
        <ml-table
          :columns="columns"
          :canChangeColWidth="true"
          :pagination="pagination"
          :loading="loading"
          :data-source="dataList"
          rowKey="id"
          :scroll="{ x: 'calc(100% - 4px)',y:'calc(100vh - 260px)'}"
          :rowSelection="{selectedRowKeys:selectedKeys,onChange:onSelectRows,
            getCheckboxProps:getCheckboxProps}"
          @change="changePage"
        >
          <template v-slot:callStatus="text">
            <span v-if="text === 0">
              {{$t('page_andon_call_no_accept')}}
            </span>
            <span v-else-if="text === 1">
              {{$t('page_andon_call_has_accept')}}
            </span>
            <span v-else-if="text === 2">
              {{$t('page_andon_call_finish')}}
            </span>

          </template>
          <template #remark="text,record,index">
            <div style="display:flex;align-items:center;" v-if="record.edit">
              <a-input :ref="'input'+index" v-model="record.remark" @blur="subEditRemark(record)"/>
            </div>
            <div style="min-height:22px;" v-else @click="columnClick(record,index)">
              {{text}}
            </div>
          </template>
        </ml-table>
      </div>
    </div>
  </div>
</template>

<script>
import { WorkStationServiceProxy } from '@/service-proxies/app-v2/workStation.service-proxies'
import { AndonTypeServiceProxy,AndonReasonServiceProxy, AndonCallRecordServiceProxy } from '@/service-proxies/app-v2/andon.service-proxies'
// const deviceTypeAndonTypeServiceProxy = new DeviceTypeAndonTypeServiceProxy();
const workStationServiceProxy = new WorkStationServiceProxy();
const andonTypeServiceProxy = new AndonTypeServiceProxy();
const andonReasonServiceProxy = new AndonReasonServiceProxy();
const andonCallRecordServiceProxy = new AndonCallRecordServiceProxy();
export default {
  created(){
    this.init();
  },
  computed:{
    isAccept(){
      if(!this.selectedRows.length){
        return false
      }else{
        let flag = this.selectedRows.some(item => item.callStatus !== 0);  // 存在不为未接受的
        if(flag){
          return false
        }else{
          return true
        }
      }
    }
  },
  methods:{
    init(){
      this.getWorkStation();
      this.getAllTypeList();
      this.getAllReasonList();
      this.getList();
    },
    // 获取工位
    getWorkStation(){
      workStationServiceProxy.getPageWorkStations(1,{},-1).then(res => {
        this.workStations = res.records || []
      })
    },

    // 获取类型
    getAllTypeList(){
      andonTypeServiceProxy.getCodeAndName().then(res => {
        this.typeList = res || []
      })
    },
    // 获取原因
    getAllReasonList(){
      andonReasonServiceProxy.getCodeAndName().then(res => {
        this.reasonList = res || [];
      })
    },
    // 重置
    onReset(){
      this.query = {};
      this.pagination.current = 1;
      this.getList();
    },
    onSearch(){
      this.pagination.current = 1;
      this.getList();
    },
    // 获取列表
    getList(){
      let data = {
        "andonReasonId": this.query.andonReasonId,
        "andonTypeId": this.query.andonTypeId,
        "workStationId": this.query.workStationId,
      }
      if(this.query.status !== undefined){
        data.callStatus = [this.query.status];
      }
      let {current,pageSize} = this.pagination;
      this.loading = true;
      andonCallRecordServiceProxy.page(data,current,pageSize).then(res => {
        this.loading = false;
        let dataList = res.records.map((item,index) => {
          item.sort = index+1;
          return item;
        });
        if(dataList.length<30){
          let addColumLength = 30 - dataList.length;
          for(let i=0;i<addColumLength;i++){
            dataList.push({})
          }
        }
        this.dataList = dataList
        this.pagination.total = res.total;
      }).catch(() => {
        this.loading = false;
      })
    },
    getCheckboxProps(record) {
      return ({
        style: {
          display: record.id ? 'block' : 'none'
        },
        props: {
          disabled: record.id ? false : true
        }
      })
    },
    changePage(pagination){
      this.pagination.current = pagination.current;
      this.pagination.pageSize = pagination.pageSize;
      this.getList();
    },
    onSelectRows(selectedKeys,selectedRows){
      this.selectedKeys = selectedKeys;
      this.selectedRows = selectedRows;
    },
    columnClick(record,index){
      if(record.callStatus == 0) return;
      this.$set(record,'oldRemark',record.remark);
      this.$set(record,'edit',true);
      this.$nextTick(() => {
        this.$refs['input'+index].focus();
      })
    },
    subEditRemark(record){
        let data = {
          "id": record.id,
          "remark": record.remark
        }
        andonCallRecordServiceProxy.updateAndonCallRecord(data).then(res => {
          this.$message.success(this.$t('page_mdc_setting_edit_success'));
          this.$delete(record,'oldRemark');
          this.$set(record,'edit',false);
        }).catch(() => {
          this.$set(record,'remark',record.oldRemark);
        })
    },
    // 呼叫接受
    onCallAccept(){
      let _this = this;
      let sorts = this.selectedRows.map(item => item.sort);
      let sortStr = sorts.join(',');
      let data = this.selectedRows.map(item => {
        return {
          callStatus:1,
          id:item.id
        }
      })
      this.$confirm({
        content: _this.$t('page_andon_call_comfirm_accept').replace('{}',sortStr)+`?`,
        onOk:() => {
          andonCallRecordServiceProxy.updateAndonCallRecordStatus(data).then(res => {
            let msg = _this.$t('page_andon_call_accept_success');
            _this.$message.success(msg);
            _this.getList();
          })
        },
        onCancel() {},
      });

    }

  },
  data(){
    return {
      query:{

      },
      labelCol:{
        span:6
      },
      wrapperCol:{
        span:18
      },
      typeList:[],  // 安灯类型下拉
      reasonList:[],  // 安灯原因
      workStations:[],
      stateList:[{
        label:this.$t('page_andon_call_no_accept'),
        value:0
      },{
        label:this.$t('page_andon_call_has_accept'),
        value:1
      },{
        label:this.$t('page_andon_call_finish'),
        value:2
      }],
      loading:false,
      columns:[
        {
          dataIndex:'sort',
          key: "sort",
          title:this.$t('serial_number'),  //"序号",
          width:50
        },
        {
          dataIndex: "andonTypeCode",
          title:this.$t('page_andon_call_type_code'),  //  "呼叫类型编码",
          width:150
        },
        {
          dataIndex: "andonTypeName",
          title:this.$t('page_andon_call_type_name'), // "呼叫类型名称",
          width:150
        },
        {
          dataIndex: "andonReasonCode",
          title:this.$t('page_andon_call_reason_code'), // "呼叫原因编码",
          width:150
        },
        {
          dataIndex: "andonReasonName",
          title:this.$t('page_andon_call_reason_name'),  // "呼叫原因名称",
          width:150
        },
        {
          dataIndex: "workStationName",
          title:this.$t('page_andon_call_station'),  // "呼叫工位",
          width:150
        },
        {
          dataIndex: "employeeName",
          title:this.$t('page_andon_call_user'),  // "呼叫人员",
          width:150
        },
        {
          dataIndex: "callStatus",
          title:this.$t('page_andon_call_status'),   // "状态",
          width:100,
          scopedSlots: { customRender: 'callStatus' }
        },
        {
          dataIndex: "description",
          title:this.$t('page_plan_description'),  // "描述",
          width:150
        },
        {
          dataIndex: "remark",
          title:this.$t('remark'),  // "备注",
          scopedSlots: { customRender: "remark" },
          width:150
        }
      ],
      pagination:{
        size:'normal',
        current:1,
        pageSize:30,
        total: 0,
        showSizeChanger: false,
        showTotal:(total) => {
          let totalStr = this.$t('Total…items').replace('{0}',total)
          return totalStr;
        }
      },
      dataList:[],
      selectedKeys:[],
      selectedRows:[]

    }
  }
}
</script>

<style lang="less" scoped>
.page-wrap{
  height: 100%;
  display: flex;
  .page-left{
    width: 320px;
    background: #fff;
    height: 100%;
    padding: 8px;
    flex-shrink: 0;
    box-shadow: 0px 0px 8px 0px rgba(0,0,0,0.1);
  }
  .page-right{
    flex:1;
    overflow: auto;
    background: #fff;
    padding: 10px;
  }
}
.action{
  text-align: center;
}
.table-wrap{
  margin-top:10px;
}

/deep/ .ant-table-scroll .ant-table-body{
  overflow-x:auto !important;
}

/deep/ .ant-table-scroll table{
  min-width: calc(~"100% - 4px") !important;
}
</style>
